import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { Pageheader } from "../../Constants/pageheader";
import { StudentListNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { useLocation } from "react-router-dom";
import { ActiveStudentList } from "../../Components/student/StudentList/ActiveStudentList";
import { GraduatedStudentList } from "../../Components/student/StudentList/GraduatedStudentList";

export const StudentListPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const section = searchParams.get("section");

  return (
    <Wrapper
      header={Pageheader.Students}
      headerNavigation={[
        {
          text: "Active Student",
          section: StudentListNavigationHeader.ACTIVE_STUDENT,
        },
        {
          text: "Graduated Student",
          section: StudentListNavigationHeader.GRADUATED_STUDENT,
        },
      ]}
    >
      {section === StudentListNavigationHeader.ACTIVE_STUDENT ? (
        <ActiveStudentList />
      ) : (
        <></>
      )}
      {section === StudentListNavigationHeader.GRADUATED_STUDENT ? (
        <GraduatedStudentList />
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
